export default {
  gutterBottom: {
    marginBottom: 8
  },
  root: {
    fontFamily: "unset !important"
  }
};
